export default __webpack_public_path__ + "static/media/evaluate-your-experiment.6f12033f.svg";